module.exports = __webpack_public_path__ + "static/groovn-66d4acfa95482912ef6478d27071c13b.png";